<template>
  <section class="maypage_wrap private_wrap">
    <modals-container
      @registBoard="registBoard"
      @registFolder="registFolder"
      @updateFolder="updateFolder"
      @deleteFolder="deleteFolder"
    ></modals-container>
    <h1 class="hide">마이페이지 프라이빗</h1>
    <PrivateHeader :groupInfo="groupInfo" @addPrivateBoard="addPrivateBoard" />

    <div class="tab_ty1" id="tabs">
      <ul class="tab-menu">
        <li
          v-for="(tab, index) in tabs"
          v-bind:class="{ active: currentTab === index }"
          :key="index"
        >
          <button type="button" @click="changeTab(index)">{{ tab }}</button>
        </li>
      </ul>
      <div class="tab-content">
        <BoardTab
          ref="boardTab"
          v-show="currentTab == 0"
          @addPrivateBoard="addPrivateBoard"
          @showNoticeToast="showNoticeToast"
        />
        <FileTab
          ref="fileTab"
          v-show="currentTab == 1"
          @addPrivateBoard="addPrivateBoard"
          @showNoticeToast="showNoticeToast"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import Paging from "@/assets/css/mypage.css";
import PrivateHeader from "./PrivateHeader";
import BoardTab from "../tab/board/BoardTab";
import FileTab from "../tab/file/FileTab";
import axios from "axios";
import RegistBoardModal from "@/components/cowork/general/board/modal/RegistBoardModal";

export default {
  name: "private",
  components: {
    PrivateHeader,
    BoardTab,
    FileTab,
  },
  data() {
    return {
      siteCheck: 0,
      groupInfo: {},
      groupName: "",
      groupId: null,
      currentTab: 0,
      currentTab2: 0,
      currentTab3: 0,
      tabs: [ this.$i18nUtil.trans("title.Private.tab.001","내가 생성한 프라이빗 보드") , this.$i18nUtil.trans("title.Private.tab.002","파일 모아보기")],
      req: {},
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },

      //뒤로가기
      prevBtn: false,
    };
  },
  computed: {
    ...mapState("mypage", ["selectedFolder"]), // 선택된 정보
  },
  beforeDestroy() {
    if (window.sessionStorage.length != 0) {
      if (window.sessionStorage.getItem("moveBoard") === "true") {
        // 보드로 이동 시에는 sessionStorage를 지우지 않음.
      } else {
        window.sessionStorage.clear();
      }
    }
  },
  created() {
    this.initGorupId();
  },
  mounted(){
    // 뒤로가기 이벤트 발생시 .
    const self = this;
    window.onpopstate = function (event) { 
      if (window.sessionStorage.getItem("private") != null) {
        let sessionState = JSON.parse(window.sessionStorage.getItem("private"));
        if (sessionState.length != 0) {
          let currnetTabInfo = sessionState.pop();
          if (window.sessionStorage.getItem("moveBoard") === "true") {
            sessionState.push(currnetTabInfo);
            window.sessionStorage.setItem(
              "private",
              JSON.stringify(sessionState)
            );
          }
          // 같은 TAB에서 뒤로가기 눌렸을시.
          else if (currnetTabInfo.currentTab == self.currentTab) {  
            if (sessionState.length == 0) {
              // window.sessionStorage.setItem("dashboard", JSON.stringify(sessionState));
              window.sessionStorage.removeItem("private");
              window.sessionStorage.removeItem("moveBoard");
              window.sessionStorage.removeItem("prevBtn");
              self.goPrevPage();
            } else {
              let currentState = sessionState.pop();
              sessionState.push(currentState);
              window.sessionStorage.setItem("private",JSON.stringify(sessionState));
              self.currentTab = currentState.currentTab; 
              self.currentTab2 = currentState.currentTab2; 
              self.currentTab3 = currentState.currentTab3; 
              self.prevBtn = true;  
              self.changeTab(self.currentTab);
              // self.initGorupId(); 
            }
          }
        } else {
        }
      }
    };
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_ACTION"]),
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showModal"]),
    ...mapActions("modals", ["showToast"]),
    initGorupId() {
      let obj = this;
      let reqData = {};
      reqData.params = {};
      reqData.req = obj.req;
      reqData.url = "/api/cogroup/cogroup/getMyGroupInfo";
      reqData.method = "post";
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          if (res.errorCode == "NOT_AUTHORIZED") {
            obj.$router.push("/general/myPage");
            obj.hideLoadingbar();
          } else if (res.errorCode == "SITE_CREATING") {
            obj.siteCheck = obj.siteCheck + 1;
            if (obj.siteCheck > 3) {
              obj.toastInfo.message =
                obj.$i18nUtil.trans("message.Private.001","프라이빗을 생성 중입니다. 잠시 후 다시 시도해주세요.");
              obj.showToast(obj.toastInfo);
              obj.$router.replace("/general/myPage");
              obj.hideLoadingbar();
            } else {
              obj.siteTimeOut = setTimeout(() => {
                obj.initGorupId();
              }, 1000);
            }
          } else if (res.errorCode == "SITE_ERROR") {
            obj.toastInfo.message = obj.$i18nUtil.trans("message.Private.002","프라이빗 생성 중 오류 발생");
            obj.showToast(obj.toastInfo);
            obj.$router.replace("/general/myPage");
            obj.hideLoadingbar();
          } else {
            this.groupInfo = res.result;
            this.groupId = res.result.groupId;
            this.groupName = res.result.groupName;

            if (window.sessionStorage.getItem("moveBoard") === "true") {
              let sessionState = JSON.parse(window.sessionStorage.getItem("private"));
              let currentState = sessionState[sessionState.length - 1];
              this.currentTab = currentState.currentTab;
              this.currentTab2 = currentState.currentTab2; 
              this.currentTab3 = currentState.currentTab3; 
            }
            this.changeTab(this.currentTab);
            // this.changeTab(0);

            obj.hideLoadingbar();
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    /* 상위 탭 클릭 */
    changeTab(index) {
      let obj = this; 

      if (index === 0) {
        this.$refs.boardTab.initGroupId(this.groupId, this.prevBtn, this.currentTab2);
      } else if (index === 1) {
        this.$refs.fileTab.initGroupIdAndGroupName(
          this.groupId,
          this.groupName,
          this.prevBtn,
          this.currentTab3
        );
      }

      obj.currentTab = index;
    },
    /* 보드 만들기 모달 호출 */
    addPrivateBoard(_data) {
      let obj = this;
      let paramCategoryMid = _data != null ? _data.categoryMid || null : null;
      let reqData = {};
      reqData.req = obj.req;
      reqData.url = "/api/copaper/paper/getGeneratedPaperId";
      reqData.method = "post";

      obj
        .COWORK_REST_ACTION(reqData)
        .then(function (res) {
          let errorCode = res.errorCode;
          let addPaperId = res.result;
          const modalInfo = {
            title: obj.$i18nUtil.trans("title.RegistBoardModal.000","업무보드 추가"),
            name: "registBoard",
            method: "post",
            width: "800px",
            // height: "493px",
            obj: obj.$modal,
            paperId: addPaperId,
            categoryMid:
              obj.selectedFolder != null
                ? obj.selectedFolder.category.categoryMid
                : paramCategoryMid,
            groupId: null,
            projectId: null,
            paperTitle: "",
            contentPath: "",
            docGrade: "SECRET",
            component: RegistBoardModal,
          };
          obj.showModal(modalInfo);
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    /* 보드 생성 API 호출 */
    registBoard(_data) {
      let obj = this;
      let paramJSON = {
        paperTitle: _data.paperTitle,
        paperId: _data.paperId,
        groupId: _data.groupId,
        categoryMid: _data.categoryMid,
        contentPath: _data.contentPath,
        docGrade: "SECRET",
        blockType: "CONTENT",
        tagList: _data.tagList,
        link: "/general/board/" + _data.paperId,
      };
      obj.showLoadingbar();
      axios
        .post("/api/copaper/paper/addPaper", paramJSON)
        .then((res) => {
          obj.hideLoadingbar();
          let errorCode = res.data.errorCode;
          if (errorCode != null) {
            return;
          }
          obj.toastInfo.message = obj.$i18nUtil.trans("TB036");
          obj.showToast(obj.toastInfo);
          obj.$router.push({ path: "/general/board/" + _data.paperId });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    registFolder(_data) {
      let obj = this;
      let reqData = {};
      reqData.params = {
        groupId: _data.groupId,
        projectId: _data.projectId,
        section: null,
        parentCategoryMid: _data.parentCategoryMid,
        categoryMid: null,
        categoryName: _data.folderName,
        sortNo: null,
        delKbn: "0",
      };
      reqData.req = obj.req;
      reqData.url = "/api/copaper/category/saveCategory";
      reqData.method = "post";
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          this.$refs.boardTab.changeBoardTab(0);
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    updateFolder(_data) {
      let obj = this;
      let reqData = {};
      reqData.params = {
        groupId: _data.selectedFolder.groupId,
        projectId: _data.selectedFolder.projectId,
        section: _data.selectedFolder.section,
        parentCategoryMid: _data.parentCategoryMid,
        categoryMid: _data.selectedFolder.categoryMid,
        categoryName: _data.folderName,
        sortNo: _data.selectedFolder.sortNo,
        delKbn: _data.selectedFolder.delKbn,
      };
      reqData.req = obj.req;
      reqData.url = "/api/copaper/category/saveCategory";
      reqData.method = "post";
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          /* 2020.11.09 / 김철환 / 단계명 변경 후 현재 탭에 따라 호출함수 분기처리 및 토스트 알림 추가 */
          if (obj.currentTab == 0) {
            this.$refs.boardTab.changeBoardTab(0);
            this.showNoticeToast(this.$i18nUtil.trans("TB023"));
          } else {
            this.$refs.fileTab.changeFileTab(1);
            this.showNoticeToast(this.$i18nUtil.trans("TB023"));
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    deleteFolder(_data) {
      _data.selectedFolder.delKbn = 1;
      let deleteFolderList = [];
      deleteFolderList.push(_data.selectedFolder);
      let obj = this;
      let reqData = {};
      reqData.params = {
        deleteFolderList: deleteFolderList,
      };
      reqData.req = obj.req;
      reqData.url = "/api/copaper/category/deleteCategoryList";
      reqData.method = "post";
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          /* 2020.11.09 / 김철환 / 단계 삭제 후 현재 탭에 따라 호출함수 분기처리 */
          if (obj.currentTab == 0) {
            this.$refs.boardTab.changeBoardTab(0);
            this.showNoticeToast(obj.$i18nUtil.trans("TB024"));
          } else {
            this.$refs.fileTab.changeFileTab(1);
            this.showNoticeToast(obj.$i18nUtil.trans("TB024"));
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    showNoticeToast(_message) {
      this.toastInfo.message = _message;
      this.showToast(this.toastInfo);
    },
    goPrevPage() {
      // this.$router.push("/general/home");
      // this.$router.push("/general/myPage");
      let returnUrls = localStorage.getItem("returnUrls");
      if(returnUrls != null) {
        let urlList = returnUrls.split(",");
        if (urlList.length > 0) {
          if (urlList.length == 1) {
            localStorage.removeItem("returnUrls");
            // this.$router.push("/general/home");
          } else {
            urlList.pop();
            localStorage.setItem("returnUrls", urlList);
            // this.$router.replace(urlList[urlList.length-1]);
          }
        } else {
          this.$router.push("/general/home");
        }
      }else{
        this.$router.push("/general/home");
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/cowork/general/mypage/private/base/Private.vue